import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formHeaderRoot: {
            backgroundColor: '#fff',
            border: '1px solid #E0E0E0',
            borderTop: 'none',
            borderBottom: 'none',
            borderRadius: 0,
            padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
            position: 'relative',
        },
        themeStripe: {
            paddingLeft: 0,
            paddingRight: 0,
            backgroundColor: '#2F80ED',
            color: 'rgba(0, 0, 0, 1)',
            height: 10,
            left: -1,
            position: 'absolute',
            top: -1,
            width: 'calc(100% + 2px)',
        },
        title: {
            fontSize: '32px',
            fontWeight: 400,
            color: '#202124',
            lineHeight: '135%',
            maxWidth: '100%',
            minWidth: '0%',
            boxSizing: 'border-box',
        },
        description: {
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '.2px',
            color: '#202124',
            lineHeight: '20px',
            whiteSpace: 'pre-wrap',
            marginTop: theme.spacing(2),
        },
        required: {
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '.2px',
            color: '#d93025',
            lineHeight: '20px',
            whiteSpace: 'pre-wrap',
            marginTop: theme.spacing(2),
        },
    }),
);
